/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Conversion_Error_Source_UnavailableInputs */

const en_conversion_error_source_unavailable = /** @type {(inputs: Conversion_Error_Source_UnavailableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.provider} could not be reached. Please try again.`)
};

const es_conversion_error_source_unavailable = /** @type {(inputs: Conversion_Error_Source_UnavailableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo contactar con ${i?.provider}. Inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "{provider} could not be reached. Please try again." |
*
* @param {Conversion_Error_Source_UnavailableInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const conversion_error_source_unavailable = /** @type {((inputs: Conversion_Error_Source_UnavailableInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversion_Error_Source_UnavailableInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_conversion_error_source_unavailable(inputs)
	return en_conversion_error_source_unavailable(inputs)
});